export var CapMixin = function CapMixin(chart, props) {
  return chart;
};